<div class="fixed-background" id="imageDiv">
    <div class="login-wrap">
        <div class="login-html" [ngClass]="{ 'login-html-size': isMobile }">
            <div class="row">
                <div class="col">
                    @if (translateService.getCurrentLang() === 'en') {
                        <img src="../../../../assets/img/eu.svg" alt="EU" />
                    }
                    @if (translateService.getCurrentLang() === 'bg') {
                        <img src="../../../../assets/img/eu2.png" alt="EU" />
                    }
                </div>
                <div class="col">
                    @if (translateService.getCurrentLang() === 'en') {
                        <img src="../../../../assets/img/trasnport2.jpg" alt="Transport" />
                    }
                    @if (translateService.getCurrentLang() === 'bg') {
                        <img src="../../../../assets/img/transport.png" alt="Transport" />
                    }
                </div>
            </div>
            @if (translateService.getCurrentLang() === 'en') {
                <div class="row text-center bottom-text">
                    The web portal is developed and maintained under project Development and implementation of a system
                    for electronic exchange of information in the Bulgarian ports (Port Community System – PCS)
                </div>
            }
            @if (translateService.getCurrentLang() === 'bg') {
                <div class="row text-center bottom-text">
                    Тази интернет страница е разработена по проект Разработване и внедряване на система за електронен
                    обмен на информация в българските пристанища (Port Community System – PCS)
                </div>
            }

            <div class="login-form tab">
                <app-loader [isBusy]="false">
                    <ng-template>
                        <form
                            class="form-forgot-pass"
                            [formGroup]="form"
                            [ngClass]="{ 'login-mobile-width': isMobile }"
                            (ngSubmit)="reset()">
                            <div class="sign-in-htm" [ngClass]="{ 'login-mobile-width': isMobile }">
                                <p class="mt-1">
                                    {{
                                        'Please enter the email address associated with your account. We will send you a link to reset your password.'
                                            | translate
                                    }}
                                </p>
                                <div class="group">
                                    <label class="label" for="pass">{{ 'Email' | translate }}</label>
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fa fa-envelope"></i></span>
                                        <form-textbox class="input-width" formControlName="email"></form-textbox>
                                    </div>
                                </div>

                                <div class="group">
                                    <button class="button" type="submit" translate [disabled]="!form.valid">
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </form>
                    </ng-template>
                </app-loader>
            </div>
        </div>
    </div>
</div>
